import Vue from 'vue/dist/vue.esm'
import template from './district_session_types_by_school_report_template.slim'
import { getUrlWithSlug, seriesData, mergeCountsBar } from '../commonChartFunctions';
import chartFilterable from '../../mixins/chart_filterable';
import barChartRange from '../../mixins/bar_chart_range';

Vue.component('district_session_types_by_school_report', {
  mixins: [template, chartFilterable, barChartRange],
  props: ['school_year_label', 'year_info', 'report_date', 'section', 'templates'],
  data() {
    return {
      chartData: {
        mastery_feedback: {},
        narrative_feedback: {},
        self_reflection: {},
        peer_visit: {}
      },
      series: [{
        name: 'Mastery Feedback Sessions',
        data: []
      }, {
        name: 'Narrative Feedback Sessions',
        data: []
      }, {
        name: 'Self Reflection Sessions',
        data: []
      }],
      chartOptions: {
        dataLabels: {
          enabled: false
        },
        chart: {
          type: 'bar',
          stacked: true,
          events: {
            dataPointSelection: (event, chartContext, config) => {
              const schoolName = config.w.config.series[0].data[config.dataPointIndex].x;
              const urlWithSlug = getUrlWithSlug(this.year_info.current_schools_year, schoolName);
              const redirectUrl = urlWithSlug + "/my_sessions";
              window.open(redirectUrl, '_blank');
            }
          }
        },
        yaxis: {
          title: {
            text: "Sessions",
            style: {
              color: '#949494'
            }
          },
          forceNiceScale: true
        },
        xaxis: {
          labels: {
            trim: true,
            rotate: -55,
          }
        },
        grid: {
          row: {
            colors: ['#FFFFFF', '#F3F3F3']
          },
          padding: {
            left: 50,
            bottom: 30
          },
        },
        colors:['#3FE6A4', '#008FFB', "#FF7878", "#00FF00"]
      }
    }
  },
  methods: {
    updateChart: function() {
      let series = [{
        name: 'Mastery Feedback Sessions',
        data: seriesData(mergeCountsBar(this.chartData.mastery_feedback, this.startDate, this.endDate))
      }, {
        name: 'Narrative Feedback Sessions',
        data: seriesData(mergeCountsBar(this.chartData.narrative_feedback, this.startDate, this.endDate))
      }, {
        name: 'Self Reflection Sessions',
        data: seriesData(mergeCountsBar(this.chartData.self_reflection, this.startDate, this.endDate))
      },
      ...(this.anyPeerVisitSessions(this.chartData.peer_visit)
        ? [{
            name: 'Peer Visit Sessions',
            data: seriesData(mergeCountsBar(this.chartData.peer_visit, this.startDate, this.endDate))
          }]
        : [])
      ];
      let sums = {};
      series.forEach(item => {
        item.data.forEach(({ x, y }) => {
          sums[x] = (sums[x] || 0) + y;
        });
      });

      series.forEach(item => {
        item.data.sort((a, b) => sums[b.x] - sums[a.x]);
      });
      this.series = series;
    },
    anyPeerVisitSessions: function(peerVisitSessions) {
       const no_pr_visit_session = Object.values(peerVisitSessions || this.chartData.peer_visit || {}).every(
        value => Object.keys(value).length === 0
      );

      return !no_pr_visit_session;
    }
  }
});
